import { useContext } from 'react'

import { Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGraduationCap, faMessageSmile, faSchool, faUserGraduate } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'

import StudentQuickMenu from '../../../Components/shared/InternshipsManager/StudentQuickMenu'
import PresetsTooltip from './ShiftTableParts/Tooltips/PresetsTooltip'
import { Contexts, InternshipStates, InternshipStatesCanBeValidated } from '../../../utils/constants'
import InternshipValidationButton from '../../../Components/shared/ShiftsManager/InternshipValidationButton'
import { SCHEDULE_VALIDATED } from '../../../utils/entities/internship'
import { GlobalContext } from '../../../Providers/GlobalProvider'
import { isObject } from '../../../utils'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import LeftFloatingCheckbox from '../../antd/Checkbox/LeftFloatinCheckbox'
import { SelectContext } from '../../../Providers/SelectProvider'
import CircularButton from '../../antd/Buttons/CircularButton'
import { ColorsPalette } from '../../../config/colors'

import '../../../assets/shifts-manager.scss'
import { InstitutionFeedbackDrawerContext } from '../../../Providers/Drawer/InstitutionFeedbackDrawer'
import { InstitutionContext } from '../../../Providers/InstitutionProvider'

const NO_SECTION_NAME = 'NONE'

const InternshipCard = ({
  canValidateDesiderata, canValidateInternship, context, displayInfoButton, internship, inWidgetMode, useCheckbox,
  onClickedDraft, onDeleteSchedule, onSelectInternship, onSelectStudent, onSelectValidation,
  onValidateDesideratas
}) => {
  const { isDraft, isReadOnly } = useContext(GlobalContext)
  const { selectedMap, setSelected } = useContext(SelectContext)
  const ic = useContext(InstitutionContext)
  const ifd = useContext(InstitutionFeedbackDrawerContext)

  const t = useSelector(selectTranslate)

  const getValidateButtonTooltip = internship => {
    if (internship.state === InternshipStates.SCHEDULE_TO_VALIDATE) {
      return t('internship_infos.validate_button.to_validate')
    }

    if (internship.state === InternshipStates.SCHEDULE_VALIDATED) {
      return t('internship_infos.validate_button.validated')
    }

    return t(`internship_infos.validate_button.${isReadOnly ? 'see' : 'validate'}`)
  }

  const getSectionName = internship => {
    let sectionName = 'NONE'

    if (internship.school === null) {
      sectionName = NO_SECTION_NAME
    } else if (internship.internshipYear?.sectionName !== 'NONE') {
      sectionName = internship.internshipYear?.sectionAbbreviation
    } else if (internship.schoolSection?.comment) {
      sectionName = internship.schoolSection?.comment
    } else if (internship.schoolSection?.name) {
      sectionName = internship.schoolSection?.name
    }

    if (internship.internshipYear) {
      sectionName += ` (${internship.internshipYear.schoolYearName})`
    } else {
      sectionName = t('internship_card.without_study_year')
    }

    return sectionName
  }

  const getStudentName = internship => {
    let name = t('internship_card.without_student')

    if (internship.student) {
      name = `${internship.student.firstname} ${internship.student.lastname}`
    }

    return name
  }

  return (
    <div className='internship-card-container'>
      <div className='internship-card-title'>
        {useCheckbox && internship.state !== SCHEDULE_VALIDATED && !isReadOnly && (
          <LeftFloatingCheckbox
            checked={!!selectedMap[internship.id]}
            style={{ borderSpacing: '0px' }}
            onChange={() => setSelected(prev => selectedMap[internship.id] ? prev.filter(i => i.id !== internship.id) : [...prev, internship])}
          />
        )}
        {!inWidgetMode && (
          <StudentQuickMenu
            canValidateDesiderata={canValidateDesiderata}
            internship={internship}
            onClickedDraft={onClickedDraft}
            onDeleteSchedule={onDeleteSchedule}
            onSelectedStudentInfo={onSelectStudent}
            onSelectedInternshipInfo={onSelectInternship}
            onValidateDesideratas={onValidateDesideratas}
            inShiftsManager
          />
        )}
        <div className='internship-information'>
          <div>
            <div className='regular-image'> <FontAwesomeIcon icon={faUserGraduate} /> </div>
            <span><b> {getStudentName(internship)} - {getSectionName(internship)}</b></span>
          </div>
          <div>
            <div className='regular-image'> <FontAwesomeIcon icon={faSchool} /> </div>
            {context === Contexts.SCHOOL && internship.institution && (
              <span> {internship.institution.name} </span>
            )}
            {context === Contexts.INSTITUTION && internship.school && (
              <span> {internship.school.name} </span>
            )}
          </div>
          <div>
            <div className='regular-image'> <FontAwesomeIcon icon={faGraduationCap} /> </div>
            <div className='last-text'>
              {internship.sector && internship.sector.parent === null ? t('Without care unit') : internship.sector.name}
            </div>
          </div>
        </div>
      </div>
      <div className={'internship-card-buttons' + (useCheckbox ? ' in-draft-mode' : '')}>
        {(displayInfoButton && !inWidgetMode) && (
          <PresetsTooltip
            presets={internship.presets}
            sectorNote={isObject(internship.sector) && isObject(internship.sector.sectorNote) ? internship.sector.sectorNote.note : null}
            internship={internship}
          />
        )}
        {canValidateInternship && !isDraft && InternshipStatesCanBeValidated.includes(internship.state) && internship.student && (
          <InternshipValidationButton
            validateButtonTooltip={getValidateButtonTooltip(internship)}
            internship={internship}
            onDisplayValidationDrawer={onSelectValidation}
          />
        )}
        {isObject(ifd) && isObject(ic) && ic.useInternshipFeedback && !isDraft && internship.state >= InternshipStates.SCHEDULE_ADDED && internship.student && (
          <Tooltip title={t('internship_card.feedback')} placement='right'>
            <div>
              <CircularButton
                className='mt-8i'
                color={ColorsPalette.DEEP_SKY_BLUE}
                icon={faMessageSmile}
                onClick={() => ifd.setHandler({ data: internship })}
              />
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  )
}

export default InternshipCard
